export default "__VITE_ASSET__4328006c__"